/**
 * O convite a instalar (Android/Chrome) depende de um evento que o browser
 * dispara UMA vez, logo no arranque — muitas vezes antes de o componente que o
 * quer usar sequer existir. Por isso quem o apanha primeiro é um script no
 * `index.html`, e aqui só o vamos buscar.
 */

export interface EventoDeInstalacao extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export const eventoDeInstalacaoGuardado = (): EventoDeInstalacao | null =>
  (window as unknown as { __pmInstallEvent?: EventoDeInstalacao }).__pmInstallEvent ?? null;

/** Um evento destes só serve uma vez — depois de usado, deita-se fora. */
export const descartarEventoDeInstalacao = (): void => {
  (window as unknown as { __pmInstallEvent?: EventoDeInstalacao }).__pmInstallEvent = undefined;
};

/** Já está no ecrã inicial? Então não há nada a convidar. */
export const jaInstalada = (): boolean =>
  window.matchMedia?.('(display-mode: standalone)').matches ||
  // iOS antigo não conhece display-mode: standalone
  (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
